import { Instance, types } from 'mobx-state-tree';

import ClientProgramGroup from './ClientProgramGroup';

const ClientScheduleProgram = types.model('ClientScheduleProgram', {
	id: types.number,
	format: types.maybeNull(types.string),
	miro_link: types.maybeNull(types.string),
	type: types.optional(types.string, ''),
	zoom_access_code: types.maybeNull(types.string),
	zoom_id: types.maybeNull(types.string),
	zoom_link: types.maybeNull(types.string),
	program_group: types.maybeNull(ClientProgramGroup),
});

export default ClientScheduleProgram;

export interface IClientScheduleProgramModel extends Instance<typeof ClientScheduleProgram> {}
